import './styles/reset.scss';
import './styles/icons.scss';
import './styles/main.scss';
import './styles/modal.scss';
import './styles/list_of_posts.scss';
import './styles/page-single.scss';

import './scripts/main';
import './scripts/modal';


import './../template-parts/blocks/who-we-are/script';
import './../template-parts/blocks/pricing/script';